<div class="container">
    <div class="ui top attached labeled icon fluid three item borderless menu">
        <!-- <a class="item" data-tab="first" routerLink="/insights" routerLinkActive="active"
        ><i class="icon user circle"></i>Insights</a
    > -->
        <a class="item" data-tab="first" routerLink="/share" routerLinkActive="active"
            ><i class="icon envelope open outline"></i>Share</a
        >
        <a class="item" data-tab="second" routerLink="/schedule" routerLinkActive="active"
            ><i class="icon calendar plus outline"></i>Schedule</a
        >
        <a class="item" data-tab="third" routerLink="/help" routerLinkActive="active"
            ><i class="icon question circle outline"></i>Help</a
        >
    </div>
    <div class="bottom attached">
        <router-outlet></router-outlet>
    </div>
</div>
